module.exports = __webpack_public_path__ + "img/04.05867187.jpg";